"use client";
import { jsx } from "react/jsx-runtime";
import { sharedHandler } from "../../../shared/sharedHandler/sharedHandler.js";
import { Text } from "@mantine/core";
import { forwardRef } from "react";
import { resolveTextColor } from "../typography.helpers.js";
import '../../../assets/Paragraph.css';const root = "_root_5k3el_2";
const ParagraphStyles = {
  root
};
const _Paragraph = forwardRef((props, ref) => {
  const {
    c,
    text,
    align,
    decoration,
    className,
    variant,
    condensed,
    strong,
    medium,
    transform,
    balanced,
    component,
    inherit,
    mod,
    heavy,
    size = "paragraph",
    classNames,
    ...rest
  } = props;
  return /* @__PURE__ */ jsx(
    Text,
    {
      ...rest,
      inherit,
      component: inherit ? "span" : size === "caption" ? "figcaption" : component || "p",
      ref,
      classNames: { ...ParagraphStyles, ...classNames },
      className,
      mod: { condensed, balanced, variant, size, ...mod },
      tt: transform,
      fw: heavy ? 700 : strong ? 600 : medium ? 500 : 400,
      ta: align,
      td: decoration,
      c: c || resolveTextColor(variant),
      children: text
    }
  );
});
_Paragraph.displayName = "Paragraph";
const Paragraph = sharedHandler(_Paragraph);
Paragraph.displayName = _Paragraph.displayName;
export {
  ParagraphStyles as P,
  Paragraph as default
};
